import { PublishedWithChanges } from '@mui/icons-material';
import { MoveCustomerToPaywall } from '../modules';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const Paywall: RouteType = {
  exact: true,
  icon: PublishedWithChanges,
  path: routePaths.paywall,
  title: 'Paywall',
  component: () => <MoveCustomerToPaywall />,
  permission: 'canMoveVenueToPaywall',
};

export default Paywall;
